import Link from '@/routing/AppLink';
import type { ButtonHTMLAttributes } from 'react';

type VariantType = 'default' | 'underline';

type SizeType = 'lg' | 'md';

interface ButtonTextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: VariantType;
  size?: SizeType;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  href?: string;
  target?: '_self' | '_blank';
  children: React.ReactNode;
}

/** hover 는 원본과 동일하게 lg 이상에서만 적용된다 */
const BASE =
  'inline-flex w-auto cursor-pointer appearance-none items-center justify-center gap-1 border-none font-medium leading-[140%] text-apps-coreGray02 outline-none transition-[color,opacity,text-decoration-color] duration-200 [&_svg]:opacity-50 [&_svg]:transition-opacity [&_svg]:duration-200 disabled:pointer-events-none disabled:text-apps-coreProductDisableContent disabled:[&_svg]:opacity-40 lg:hover:text-apps-coreGrayBlack lg:hover:[&_svg]:opacity-100';

const SIZE_CLASS: Record<SizeType, string> = {
  lg: 'text-base tracking-[-0.32px]',
  md: 'text-sm tracking-[-0.28px]',
};

const VARIANT_CLASS: Record<VariantType, string> = {
  default: '',
  underline: '[&>span]:-mb-px [&>span]:border-b [&>span]:border-solid',
};

export default function ButtonText({
  variant = 'default',
  size = 'md',
  iconLeft,
  iconRight,
  href,
  target,
  children,
  disabled = false,
  className,
  ...props
}: ButtonTextProps) {
  const button = (
    <button
      className={`${BASE} ${SIZE_CLASS[size]} ${VARIANT_CLASS[variant]} ${className ?? ''}`}
      disabled={disabled}
      {...props}
    >
      {iconLeft && iconLeft}
      <span>{children}</span>
      {iconRight && iconRight}
    </button>
  );

  if (href) {
    return (
      <Link
        href={href}
        target={target}
        prefetch={false}
        className={`flex ${disabled ? 'pointer-events-none' : ''}`}
      >
        {button}
      </Link>
    );
  }

  return button;
}
